module.exports = __webpack_public_path__ + "static/img/Jennifer_Tran.63ae1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Jennifer_Tran.png
// module id = 1562
// module chunks = 5